import React from "react";
import { Link } from "react-router-dom";
import "./Allprojects.css";

const projects = [
  {
    title: "SR 509, I-5 to 24th Ave S — Stage 1",
    year: "Current",
    img: `${process.env.PUBLIC_URL}/IMG_38191.jpg`,
   
    location: "Washington State, United States",
    type: "Highway Infrastructure",
    tags: ["MSE Walls", "Underground Utilities", "Roadwork", "Trucking"],
    owner: "WSDOT",
    contractor: "Atkinson Construction",
    scope: "MSE walls, underground utilities, roadwork, and trucking."
  },
  {
    title: "Foothill Trail PH2",
    year: "Completed",
    img: `${process.env.PUBLIC_URL}/IMG_7813.jpg`,
    
    location: "King County, Washington",
    type: "Trail / Bridge",
    tags: ["Detention Tank", "Soil Nail Wall", "Grading", "Roadwork"],
    owner: "King County",
    contractor: "Kraemer",
    scope:
      "Underground detention tank, facing soil nail wall, grading, and roadwork for bridge."
  },
  {
    title: "Bigelow Gulch Road Project #2",
    year: "—",
    img: `${process.env.PUBLIC_URL}/bigel.png`,
  
    location: "Spokane County, Washington",
    type: "Road Project",
    tags: ["Underground Utilities", "CMP Culvert"],
    owner: "Spokane County",
    contractor: "Scarsella Bros.",
    scope: "Underground utilities and install 84” CMP culvert."
  },
  {
    title: "SR 20 Olson Creek ",
    year: "2024",
    img: `${process.env.PUBLIC_URL}/atinksonone.jpg`,
   
    location: "Washington State, United States",
    type: "Bridge / Culvert",
    tags: ["Voided Slab Bridge", "Box Culvert", "Weekend Closure"],
    owner: "WSDOT",
    contractor: "Atkinson Construction",
    scope:
      "Set voided slab bridge and install box culvert over a weekend closure."
  },
  {
    title: "SR 167, I-5 to SR 509",
    year: "2024",
    img: `${process.env.PUBLIC_URL}/atinkson.jpg`,
   
    location: "Washington State, United States",
    type: "Highway Infrastructure",
    tags: [
      "Roadwork",
      "Underground Drainage",
      "Stream Mitigation",
      "Geosynthetic Walls",
      "Box Culverts"
    ],
    owner: "WSDOT",
    contractor: "Atkinson Construction",
    scope:
      "Roadwork, underground drainage, stream mitigation, geosynthetic walls, installation of box culverts, and stream diversion."
  }
];

const Allprojects = () => {
  return (
    <section className="Allprojects" id="projects">
      <div className="Allprojects__container">
        <div className="Allprojects__header">
          <p className="Allprojects__eyebrow">CURRENT &amp; PAST PROJECTS</p>
          <h1 className="Allprojects__title">Where Ideas Become Infrastructure</h1>
          <p className="Allprojects__sub">
            Showcasing highway, bridge, underground, and sitework projects .
          </p>
        </div>

        <div className="Allprojects__grid">
          {projects.map((project, idx) => (
            <article key={idx} className="Allprojects__card">
              <div className="Allprojects__cardBadge">{project.type}</div>

              <div className="Allprojects__cardHead">
                <div className="Allprojects__cardHeadInner">
                  <h3 className="Allprojects__cardName">{project.title}</h3>
        
                </div>
              </div>

              <figure className="Allprojects__figure">
                <img
                  src={project.img}
                  alt={project.title}
                  className="Allprojects__img"
                  loading="lazy"
                />
                <div className="Allprojects__imgOverlay"></div>
              
              </figure>

              <p className="Allprojects__desc">{project.description}</p>

              <div className="Allprojects__clientInfo">
                <div className="Allprojects__clientItem">
                  <span className="Allprojects__clientLabel">Owner:</span>
                  <span className="Allprojects__clientValue">{project.owner}</span>
                </div>
                <div className="Allprojects__clientItem">
                  <span className="Allprojects__clientLabel">General Contractor:</span>
                  <span className="Allprojects__clientValue">{project.contractor}</span>
                </div>
              </div>

              <div className="Allprojects__scope">
                <h4 className="Allprojects__scopeTitle">Project Scope</h4>
                <p className="Allprojects__scopeDesc">{project.scope}</p>
              </div>

              <div className="Allprojects__tags">
                {project.tags.map((tag, i) => (
                  <span key={i} className="Allprojects__tag">{tag}</span>
                ))}
              </div>

              <div className="Allprojects__meta">
                <div className="Allprojects__chip">
                  <span className="Allprojects__chipLabel">Location</span>
                  <span className="Allprojects__chipValue">{project.location}</span>
                </div>
                <div className="Allprojects__chip">
                  <span className="Allprojects__chipLabel">Project Type</span>
                  <span className="Allprojects__chipValue">{project.type}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

       
      </div>
    </section>
  );
};

export default Allprojects;
